import { startLogin } from "@auth/login"
import { createFileRoute, getRouteApi } from "@tanstack/react-router"
import type { FC } from "react"

import { ErrorScreen } from "./-components/ErrorScreen"

const routeApi = getRouteApi("/error")

// ErrorRedirect("Invalid issuer in login request");
// ErrorRedirect("Missing login cookie")
// ErrorRedirect("State mismatch in login request");
// ErrorRedirect("Error communicating with identity provider");
// These are all the possible error message from backends 302 responses
// They're grabbed from the url param 'message' and then
// All of these are mapped to a user friendly message below
const AUTH_ERROR_MESSAGES: Record<string, string> = {
  "Missing login cookie": "Your session expired — please sign in again.",
  "State mismatch in login request":
    "Your login was interrupted — please try again.",
  "Invalid issuer in login request":
    "We couldn't verify your login — please try again.",
  "Error communicating with identity provider":
    "We couldn't reach the login service — please try again shortly.",
}

const ErrorPage: FC = () => {
  const { message }: { message?: string } = routeApi.useSearch()
  const sanitizedMessage = message
    ? (AUTH_ERROR_MESSAGES[message] ?? message)
    : "Unknown error"

  return (
    <ErrorScreen
      title="Something went wrong"
      message={sanitizedMessage}
      action={{ label: "Try again", onClick: () => void startLogin() }}
    />
  )
}

export const Route = createFileRoute("/error")({
  validateSearch: (search: { message?: string }) => search,
  component: ErrorPage,
})
